import type {CohortVisitLinkTriggerStruct} from '@cohort/shared/schema/apps/cohort/triggers/visitLink';
import type {DetailsComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';

const CohortVisitLinkTriggerIntegrationDetailComponent: React.FC<
  DetailsComponentProps<CohortVisitLinkTriggerStruct>
> = ({config}) => {
  const {accentColor} = useThemeContext();

  return (
    <div className="flex flex-col gap-4">
      <a href={config.url} style={{color: accentColor}} target="_blank" rel="noreferrer">
        {config.url}
      </a>
    </div>
  );
};

export default CohortVisitLinkTriggerIntegrationDetailComponent;
